import React from "react";
import { Box, Grid, TextField } from "@mui/material";
import { GlobalBox } from "components/Box/GlobalBox";
import RegularButton from "components/CustomButtons/Button";
import { useForm } from "hooks/useForm";
import { initialValues } from "./inputValues";
import { useDispatch } from "react-redux";
import { prepareInvoiceData } from "redux/actions/invoices/invoicesCashAction";
import { useCommentsHook } from "./useCommentsHook";
import { commentsConfig } from "./config"

export const CommentsInvoices = () => {
  const dispatch = useDispatch()
  const {
    values, onChange, validate, reset
  } = useForm(initialValues.comments)

  useCommentsHook({values, validate, reset})
  return (
    <Grid item xs={12}>
      <GlobalBox
        title={commentsConfig.title}
        head
        style={{ boxShadow: "none", margin: 0 }}
        styleBody={{ paddingLeft: 0, paddingRight: 0 }}
      >
        <TextField
          variant="outlined"
          label={commentsConfig.label}
          name={commentsConfig.name}
          value={values.comment}
          onChange={onChange}
          fullWidth
          multiline
          rows={3}
        />
        <Box
          sx={{
            width: "100%",
            textAlign: "right",
          }}
        >
          <RegularButton color="info" onClick={() => dispatch(prepareInvoiceData(true))}> {commentsConfig.buttonName} </RegularButton>
        </Box>
      </GlobalBox>
    </Grid>
  );
};
